<div class="{{ this.isDesktop ? 'view-desktop' : 'view-mobile' }}">
    <div class="result">
        <!-- TODO: check if evaluationAthlete?.answers.length > 0 -->
        <div fxLayout="fxLayoutGap">
            <div fxFlex="100">
                <mat-card>
                    <evaluation-athlete-spider-chart
                        [evaluationAthlete]="evaluationAthlete"
                        [isDesktop]="this.isDesktop"
                        [selectedEvaluations$]="selectedEvaluations$">
                    </evaluation-athlete-spider-chart>
                    <div *ngIf="isDesktop" class="bottom-buttons">
                      <button mat-button
                              (click)="onSelectAllClicked()">
                              <mat-icon>select_all</mat-icon>
                              <span>{{ 'SelectAllEvaluations' | translate }}</span>
                      </button>
                      <button mat-button
                              (click)="onSelectNoneClicked()">
                              <mat-icon>border_clear</mat-icon>
                              <span>{{ 'SelectNoneEvaluations' | translate }}</span>
                      </button>
                    </div>
                </mat-card>
            </div>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" class="mt-40">
            <div fxFlex.lg="50">
                <div class="result-answer">
                    <div class="user user-athlete">
                        {{ 'evaluation_test' | translate }} - {{ evaluationAthlete.date | appDate:'dd.MM.yy' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #noAthleteEvaluation>
    <div class="evaluation-athlete-no-evaluation">
        {{ 'No_Athlete_Evaluation_Answers'|translate }}
    </div>
</ng-template>
